export default __webpack_public_path__ + "static/media/recorder.6bab959f.svg";